import React, { Component } from 'react'
import './App.css'
import LayoutPage from './pages/LayoutPage'

class App extends Component {
  render() {
    return (
      <div className="App">
        <LayoutPage />
      </div>
    )
  }
}

export default App
